import { Ref, useEffect, useState } from "react";

export function useScrolledElement(referenceSectionRef: React.MutableRefObject<any>, priceRef: React.MutableRefObject<any>){
  // State to track whether the user has scrolled past the reference section
  const [hasScrolled, setHasScrolled] = useState(false);
  const [hasScrolledPrice, setHasScrolledPrice] = useState(false);


  // Function to handle scroll and intersection observer events
  const handleScroll = (entry:any) => {
    const referenceSection = referenceSectionRef.current;
    const priceSection = priceRef.current;
    if (referenceSection && entry.target.id === 'start-price') {
      // Set hasScrolled to true if the reference section is in view
      // or within 100 pixels below the viewport
      if(!entry)return 
      const referenceSectionInView = entry.isIntersecting || window.pageYOffset >= (referenceSection.offsetTop)
      // const priceSectionInView = entry[1].isIntersecting
      // console.log('inView', priceSectionInView)
      setHasScrolled(referenceSectionInView)
    }

    if(priceSection && entry.target.id === 'price-section'){
      if(!entry)return 
      // const referenceSectionInView = entry.isIntersecting || window.pageYOffset >= (referenceSection.offsetTop)
      // console.log('price section in view', entry.isIntersecting)
      setHasScrolledPrice(entry.isIntersecting)
    }
  };
  
  useEffect(() => {
    // Add event listener for scroll event when component mounts
    window.addEventListener('scroll', handleScroll);

    // Create an Intersection Observer instance
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          handleScroll(entry);
        })
        // console.log('entries', entries)
        // Set hasScrolled to true if the reference section is in view
        
        // handlePriceScroll(entries[1])
      },
      { threshold: 0 }
    );

    // Observe the reference section element
    if (referenceSectionRef.current && priceRef.current) {
      const elements = [
        referenceSectionRef.current,
        priceRef.current
      ]
      elements.forEach(element => {
        observer.observe(element);
      })
    }

    // Clean up event listener and observer when component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
      const elements = [
        referenceSectionRef.current,
        priceRef.current
      ]
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);


  return {
    hasScrolled,
    hasScrolledPrice
  };
}